export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-star-fill text-background-50 text-xl"></i>
              </span>
              <span className="text-lg font-heading font-bold text-background-50">星星动漫网</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              星星动漫网是国内领先的免费漫画在线阅读平台，汇集韩漫、日漫、国漫等各类好看的漫画。高清画质下拉式阅读，每日更新，漫画大全尽在星星动漫网。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <nav className="flex flex-col gap-2">
              <a href="#ranking" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">热门排行</a>
              <a href="#carousel" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">焦点专题</a>
              <a href="#updates" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">更新动态</a>
              <a href="#index" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">漫画索引</a>
              <a href="#cards" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">推荐漫画</a>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">分类浏览</h4>
            <nav className="flex flex-col gap-2">
              <a href="#index" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">韩漫精选</a>
              <a href="#index" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">日漫经典</a>
              <a href="#index" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">国漫专区</a>
              <a href="#index" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">热血战斗</a>
              <a href="#index" className="text-sm text-background-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">恋爱甜宠</a>
            </nav>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-500">诚邀优质合作伙伴加入</p>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 星星动漫网 - 韩漫日漫国漫漫画大全，好看的漫画全集免费在线阅读
          </p>
          <div className="flex items-center gap-4">
            <a href="#contact" className="text-xs text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">联系我们</a>
            <a href="#faq" className="text-xs text-background-500 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer">常见问题</a>
          </div>
        </div>
      </div>
    </footer>
  );
}